import { render, staticRenderFns } from "./viewtag.vue?vue&type=template&id=060eeefe&scoped=true&"
import script from "./viewtag.vue?vue&type=script&lang=js&"
export * from "./viewtag.vue?vue&type=script&lang=js&"
import style0 from "./viewtag.vue?vue&type=style&index=0&id=060eeefe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "060eeefe",
  null
  
)

export default component.exports